import { useRef} from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

export default function HomeBanner() {
    const sliderRef = useRef(null);
            
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "linear",
        autoplaySpeed: 0,
        speed: 5000,
        responsive: [
        {
            breakpoint: 767,
            settings: { slidesToShow: 3, speed: 3000, },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 4 },
        },
        ],
    };
  return (
    <>
    <div className="banner-section">
        <div className="container">
            <div className="row">  

                <div className="col-lg-7 col-sm-7">
                    <div className="homebanner-text">
                        <div>
                            <h1 className='heading'>Luxury Interiors, Crafted to <span>Perfection</span></h1>
                            <p>Transform your spaces into iconic living experiences that combine elegance, functionality, and timeless craftsmanship.</p>
                            <Link to={"/project"} className="default-btn">Explore <Icons name="Longarrow_right"/></Link>
                        </div>
                    </div>
                </div>

                <div className="col-lg-5 col-sm-5">
                    <div className="homebanner-slider">
                        <div className="bannerslide-box">
                            <p className="slidebox-head"><img src="/image/crown.svg" alt="crown"/> Over 1000+ projects completed</p>

                            <Slider {...settings} ref={sliderRef} className="bannerthumb-slider">
                                <div>
                                    <div className="banner-thumb">
                                    <img src="/image/landthumb-1.webp" className="img-responsive" alt="banner"/>
                                    </div>
                                </div>

                                <div>
                                    <div className="banner-thumb">
                                    <img src="/image/landthumb-2.webp" className="img-responsive" alt="banner"/>
                                    </div>
                                </div>

                                <div>
                                    <div className="banner-thumb">
                                    <img src="/image/landthumb-3.webp" className="img-responsive" alt="banner"/>
                                    </div>
                                </div>

                                <div>
                                    <div className="banner-thumb">
                                    <img src="/image/landthumb-4.webp" className="img-responsive" alt="banner"/>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <img src="/image/landbanner-1.webp" className="banner-image" alt="banner"/>
        <div className="banner-topoverlay"></div>
    </div> 
    </>
  )
}
